module.exports = __webpack_public_path__ + "img/excluir-documento.bf1841aa.svg";